import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { RefreshActions } from '../state/refresh'
import { useRequests } from '../requests/useRequests'
import { Brand } from '../types/brand'

export const useBrandZone = () => {
  const dispatch = useDispatch()
  const requests = useRequests()
  const [searchParams, setSearchParams] = useSearchParams()

  const [brands, setBrands] = useState<Brand[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [searchQuery, setSearchQuery] = useState<string>(searchParams.get('search') || '')
  const [totalCount, setTotalCount] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(parseInt(searchParams.get('page') || '1', 10))
  const [totalPages, setTotalPages] = useState<number>(1)
  const [itemsPerPage, setItemsPerPage] = useState<number>(12)

  const showToast = (message: string) => {
    dispatch(
      RefreshActions.setToastMessage({
        message
      })
    )
  }

  useEffect(() => {
    loadBrands()
  }, [searchQuery, currentPage, itemsPerPage])

  useEffect(() => {
    updateSearchParams()
  }, [searchQuery, currentPage])

  const loadBrands = () => {
    setLoading(true)

    requests.getBrands({
      page: currentPage,
      limit: itemsPerPage,
      searchQuery: searchQuery || undefined
    })
      .then(response => {
        setBrands(response.data.data)
        setTotalCount(response.data.meta.total)
        setTotalPages(response.data.meta.pages)
        setLoading(false)
      })
      .catch(error => {
        showToast('Wystąpił błąd podczas pobierania danych')
        setLoading(false)
      })
  }

  const updateSearchParams = () => {
    const params = new URLSearchParams()

    if (searchQuery) params.set('search', searchQuery)
    if (currentPage > 1) params.set('page', currentPage.toString())

    setSearchParams(params)
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value)
    setCurrentPage(1)
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  const handleItemsPerPageChange = (value: number) => {
    setItemsPerPage(value)
    setCurrentPage(1)
  }

  return {
    brands,
    loading,
    searchQuery,
    currentPage,
    totalPages,
    totalCount,
    itemsPerPage,
    handleSearch,
    handlePageChange,
    handleItemsPerPageChange,
    showToast
  }
}
